import { Screen } from '@stashinvest/product-events-typescript';

export const SET_PORTFOLIO_CONVERSION_ACCOUNT_ID =
	'SET_PORTFOLIO_CONVERSION_ACCOUNT_ID';
export const SET_DEEPEST_CONVERSION_SCREEN = 'SET_DEEPEST_CONVERSION_SCREEN';
export const SET_DID_SUBMIT_CONVERSION = 'SET_DID_SUBMIT_CONVERSION';
export const RESET_MANAGED_TRANSITION_EXIT_STATE =
	'RESET_MANAGED_TRANSITION_EXIT_STATE';

// Funnel-depth values the slice tracks for `ManagedTransitionFlow_Exited`.
// `Screen.managedTransitionResults` is intentionally excluded — by the time
// the user reaches the Results/Confirmation screen, `didSubmitConversion` is
// already true and the funnel value is moot (iOS does the same).
export type ManagedTransitionExitScreen =
	| typeof Screen.managedTransitionPrimer
	| typeof Screen.managedTransitionHowItWorks
	| typeof Screen.managedTransitionAccountOverview
	| typeof Screen.managedTransitionAutoStash
	| typeof Screen.managedTransitionSummary;

export type SetPortfolioConversionAccountIdAction = {
	type: typeof SET_PORTFOLIO_CONVERSION_ACCOUNT_ID;
	payload: { accountId: string | null };
};

export type SetDeepestConversionScreenAction = {
	type: typeof SET_DEEPEST_CONVERSION_SCREEN;
	payload: { screen: ManagedTransitionExitScreen };
};

export type SetDidSubmitConversionAction = {
	type: typeof SET_DID_SUBMIT_CONVERSION;
	payload: { didSubmitConversion: boolean };
};

export type ResetManagedTransitionExitStateAction = {
	type: typeof RESET_MANAGED_TRANSITION_EXIT_STATE;
};

export const setPortfolioConversionAccountId = (
	accountId: string | null
): SetPortfolioConversionAccountIdAction => ({
	type: SET_PORTFOLIO_CONVERSION_ACCOUNT_ID,
	payload: { accountId },
});

export const setDeepestConversionScreen = (
	screen: ManagedTransitionExitScreen
): SetDeepestConversionScreenAction => ({
	type: SET_DEEPEST_CONVERSION_SCREEN,
	payload: { screen },
});

export const setDidSubmitConversion = (
	didSubmitConversion: boolean
): SetDidSubmitConversionAction => ({
	type: SET_DID_SUBMIT_CONVERSION,
	payload: { didSubmitConversion },
});

export const resetManagedTransitionExitState =
	(): ResetManagedTransitionExitStateAction => ({
		type: RESET_MANAGED_TRANSITION_EXIT_STATE,
	});
